import React, { Component } from 'react';
import moment from 'moment';
import { DateRange } from 'react-date-range';
import defaultRanges from '../components/defaultRanges';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetch_queryInfo } from '../actions/index';
import '../styles/date_range_picker.css';

class DatePicker_custom extends Component {
	constructor(props, context) {
    super(props, context);
    this.state = {
      'rangePicker' : {},
      'linked' : {},
      'datePicker' : null,
      'firstDayOfWeek' : null,
      'predefined' : {},
      'showdatepicker':'none'
    }
  }

  handleChange(which, payload) {
    this.setState({
      [which] : payload
    });
  }

  datepickerClick(){
  	this.setState({showdatepicker:'block'})
  }

  datepickerApply(){
  	this.setState({showdatepicker:'none'})
    const startDate = this.state.predefined['startDate'].format('YYYY/MM/DD').toString().replace(/\//g,"-"); 
    const untilDate = this.state.predefined['endDate'].format('YYYY/MM/DD').toString().replace(/\//g,"-");
    this.props.fetch_queryInfo(this.props.queryInfo.q,startDate, untilDate)
  }
  datepickerCancel(){
  	this.setState({showdatepicker:'none'})
  }

  render() {
    const { rangePicker, linked, datePicker, firstDayOfWeek, predefined} = this.state;
    const format = 'YYYY/MM/DD';

return (
			<div className="dateRangePicker">
          <div className="dateRangeTitle">
            <p className="dateStatusSection" onClick={()=>this.datepickerClick()}>
              <input
                type='text'
                readOnly
                value={ `${predefined['startDate'] && predefined['startDate'].format(format).toString()} - ${predefined['endDate'] && predefined['endDate'].format(format).toString()}` }
              />
              <span className="sprite4 sprite-icon-settingdate"></span>
            </p>
          </div>
          <div className="dateRangeDropdown" style={{background:'#F7F7F7',width:'650px', display:`${this.state.showdatepicker}`}}>
	          <DateRange
              startDate={ now => { return now.add(-7, 'days') } }
              endDate={ now=> {return now.add(-1, 'days')}}
	            minDate= {now => {return now.add(-360, 'days')}}
	          	maxDate={ now => {return now.add(-1,'days')}}
	            linkedCalendars={ true }
	            ranges={ defaultRanges }
	            onInit={ this.handleChange.bind(this, 'predefined') }
	            onChange={ this.handleChange.bind(this, 'predefined') }
	            theme={{
	              Calendar : { width: 230 }
	            }}
	            lang='cn'
	          />
	          <FlatButton backgroundColor="#FFEA29" onClick={()=>this.datepickerApply()}>確認</FlatButton>
	          <FlatButton style={{color: '#fff'}} backgroundColor="#000" onClick={()=>this.datepickerCancel()}>取消</FlatButton>
          </div>
			</div>

		)
	}
}

function mapStateToProps({queryInfo}) {
  return { queryInfo };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetch_queryInfo }, dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(DatePicker_custom);


// WEBPACK FOOTER //
// ./src/containers/date_range_picker.js